export default "__VITE_ASSET__B8ktAnq4__"